// extracted by mini-css-extract-plugin
export default {"container":"fda-z","tab":"gda-z","selected":"hda-z"};